import { Dialog } from "@shared/ui/Dialog";
import { Loader } from "@shared/ui/Loader";
import { Meeting } from "@platform/types/platform.types";
import ProgramCalendarEventList from "./ProgramCalendarEventList";
import { TimezoneOption } from "@platform/features/timezones/timezones.types";

export type Props = {
  meetings?: Meeting[];
  isOpen: boolean;
  onClose: () => void;
  userTimezone?: TimezoneOption;
  onAddCalendarEvent: (
    meetingId: number | "all",
    calendarType: "google" | "ical"
  ) => void;
};

export function ProgramAddCalendarEventsDialog({
  meetings,
  userTimezone,
  isOpen = true,
  onClose,
  onAddCalendarEvent,
}: Props) {
  return (
    <Dialog
      title="Add Meetings to Calendar"
      isOpen={isOpen}
      onClose={onClose}
      containerClassName="pb-4"
      size="2xl"
    >
      {meetings ? (
        <ProgramCalendarEventList
          meetings={meetings}
          userTimezone={userTimezone}
          onAddCalendarEvent={onAddCalendarEvent}
        />
      ) : (
        <Loader isAbsolute />
      )}
    </Dialog>
  );
}

export default ProgramAddCalendarEventsDialog;
